export default {"src":"/_next/static/media/PencilSimple.6da015c2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};